import React from "react";

const PatientsIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      id="patients_icon"
      data-name="patients"
      {...props}
      width={props.width || "20"}
      height={props.height || "20"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.8366 9.20668C14.3442 8.34175 14.5634 7.33777 14.4625 6.34001C14.3133 4.85335 13.4833 3.53918 12.1266 2.64001L11.2058 4.02835C12.1383 4.64668 12.7058 5.52752 12.8041 6.50668C12.8495 6.96176 12.7928 7.42123 12.6383 7.85167C12.4838 8.2821 12.2353 8.67269 11.9108 8.99501L10.9175 9.98835L12.2658 10.3842C15.7925 11.4175 15.8333 14.9642 15.8333 15H17.5C17.5 13.5092 16.7033 10.5958 13.8366 9.20668Z"
        fill={props.fill || "#3A8AB9"}
      />
      <path
        d="M7.91675 10C9.75508 10 11.2501 8.50504 11.2501 6.66671C11.2501 4.82837 9.75508 3.33337 7.91675 3.33337C6.07841 3.33337 4.58341 4.82837 4.58341 6.66671C4.58341 8.50504 6.07841 10 7.91675 10ZM7.91675 5.00004C8.83591 5.00004 9.58341 5.74754 9.58341 6.66671C9.58341 7.58587 8.83591 8.33337 7.91675 8.33337C6.99758 8.33337 6.25008 7.58587 6.25008 6.66671C6.25008 5.74754 6.99758 5.00004 7.91675 5.00004ZM9.16675 10.8334H6.66675C3.90925 10.8334 1.66675 13.0759 1.66675 15.8334V16.6667H3.33341V15.8334C3.33341 13.995 4.82841 12.5 6.66675 12.5H9.16675C11.0051 12.5 12.5001 13.995 12.5001 15.8334V16.6667H14.1667V15.8334C14.1667 13.0759 11.9242 10.8334 9.16675 10.8334Z"
        fill={props.fill || "#3A8AB9"}
      />
    </svg>
  );
};

export default PatientsIcon;
